import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";

export default class DatePicker extends HTMLDivElement {

    constructor() {
        super();
        this.datePickerInput = this.querySelector('input');
    }

    connectedCallback() {
        let formatToApply = this.datePickerInput.getAttribute('data-format');
        let displayTimePicker = this.datePickerInput.getAttribute('data-display-timepicker');

        if(!displayTimePicker){
            displayTimePicker = false;
        }

        var options = {
            dateFormat: formatToApply,
            locale: French,
            allowInput:true,
            position: "below left",
            monthSelectorType:'static',
            enableTime:displayTimePicker
        };

        if(this.datePickerInput.getAttribute('data-linked-element'))
        {
            let dateLinkedInput = document.querySelector('[name="' + this.datePickerInput.getAttribute('data-linked-element') + '"]');
            options.onChange = function(selectedDates, dateStr, instance) {
                var fpLinkedInput  = dateLinkedInput._flatpickr; // Récupération de l'instance flatpickr de l'input
                fpLinkedInput.set('minDate', selectedDates[0]);
            }
        }
        this.datePickerInput.flatpickr(options);
    }
}
